"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAdminAuth = void 0;
exports.workspaceAdminAuth = function (axios) {
    return {
        postWorkspaceAdminAuthTokenServerApiCode: function (request) {
            return axios.post('/auth/token/server-api/code', request.data);
        },
        postWorkspaceAdminAuthTokenServerApiLongLived: function (request) {
            return axios.post('/auth/token/server-api/long-lived', request.data);
        }
    };
};
